import { Fee, FeeConfigScope, FeesSemantics } from "models/fees"

import { http } from "./http"

export const fetchFees = async (
  _key: string,
  configScope?: FeeConfigScope,
  configOwnerId?: string,
) => {
  const searchParams = new URLSearchParams()
  !!configScope && searchParams.set("configScope", configScope)
  !!configOwnerId && searchParams.set("configOwnerId", configOwnerId)
  const { data } = await http
    .get(`fees`, { searchParams })
    .json<{ data: Fee[] }>()
  return data
}

export const createFee = async (pld: Partial<Fee>) => {
  const json = pld
  const res = await http.post("fees", { json }).json()
  return res as Fee
}

export const patchFee = async (pld: Partial<Fee>): Promise<Fee> => {
  const { id, ...data } = pld
  const res = await http.patch(`fees/${pld.id}`, { json: data }).json()
  return res as Fee
}

export const deleteFee = async (id: string) => await http.delete(`fees/${id}`)

export const fetchFeeSemantics = async (
  _key: string,
  scope: Partial<FeeConfigScope>,
) => {
  const searchParams = new URLSearchParams()
  !!scope && searchParams.set("scope", scope)
  const { data } = await http
    .get(`fees/semantics`, { searchParams })
    .json<{ data: FeesSemantics[] }>()
  return data
}
